
import { cn } from '@/lib/utils';
import { choiceSelectedSurface, choiceUnselectedSurface } from './formFieldStyles';

export interface PillOption {
  value: string;
  label: string;
}

export interface PillGroupProps {
  name: string;
  label?: string;
  helperText?: string;
  options: PillOption[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  className?: string;
}

export function PillGroup({
  name,
  label,
  helperText,
  options,
  value,
  onChange,
  error,
  required,
  className,
}: PillGroupProps) {
  return (
    <div className={cn('w-full', className)} role="radiogroup" aria-label={label}>
      {label && (
        <span className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
          {label}
          {required && (
            <span className="text-red-500 dark:text-red-400 ml-0.5" aria-hidden="true">
              *
            </span>
          )}
        </span>
      )}
      {helperText && (
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-2">{helperText}</p>
      )}
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isSelected = value === option.value;
          return (
            <label
              key={option.value}
              className={cn(
                'cursor-pointer rounded-full px-4 py-2 text-sm font-medium transition-all duration-200',
                'focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-offset-2',
                isSelected ? choiceSelectedSurface : choiceUnselectedSurface
              )}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={isSelected}
                onChange={() => onChange(option.value)}
                className="sr-only"
              />
              {option.label}
            </label>
          );
        })}
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600 dark:text-red-400" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
